<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid">
      <div class="row mt-md-4">
        <div class="col-12">
          <div class="w-100">
            <h1 class="main-title">Rancangan Kegemaran</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row pb-2">
        <div class="col-12 mt-2">
          <div class="fullwidth d-flex flex-row flex-wrap">
            <div
              class="col-6 col-md-3 col-lg-2 px-1 py-3 px-md-1 py-md-4 item"
              v-for="(item, idx) in vod_each"
              :key="'favorite' + idx"
              @click="goTo(getAssetLink(item))"
            >
              <div>
                <favoriteCard
                  :order="idx + 1"
                  :image="item.img_link"
                  :title="item.content.longTitle"
                  :link="item.redirect_url"
                  :index="idx"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3" v-if="show_load_more">
          <div class="w-100 d-flex justify-content-center">
            <div class="load-more" @click="loadMore()">
              Load more
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import noimage from "../assets/noimage.png";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
import favoriteCard from "../components/cards/v2/favoriteCard.vue";
import axios from "axios";
export default {
  name: "viewall",
  data: function() {
    return {
      vod: [],
      vod_each: [],
      news: [],
      specials: [],
      podcast: [],
      categoryTitle: "",
      backlink: "",
      offset: 0,
      cat_id: this.$route.query.cat_id,
      api_link: "",
      total_count: "",
      show_load_more: false,
      userID: localStorage.getItem("user_id"),
    };
  },
  components: {
    BreadCrumbsHeader,
    favoriteCard,
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "Favorite",
          referrer: "Direct",
          site: "RTMKlik",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializeContentForStart() {
      // check type of view all either vod or podcast
      // get type of category, e.g from rails, or from category page
      // get getCategoryID
      //   https://rtm.glueapi.io/v1/user/${this.userID}/content/favourite?limit=300&fields=title,slug,data.image,idSchema&nocache=${Date.now()}
      //   const rtmKlikDomain = "https://rtm.glueapi.io/v3";

      let url = `https://rtm.glueapi.io/v1/user/${
        this.userID
      }/content/favourite?limit=30`;
      this.api_link = url;

      this.getItems(url, 0);
    },
    async getItems(url, offset) {
      const token = localStorage.getItem("token");
      try {
        axios
          .get(`${url}&offset=${offset}`, {
            headers: {
              "X-AUTH-TOKEN": token,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            this.assignItems(response.data);
          });
      } catch (e) {
        console.log(e);
      }
    },
    assignItems(obj) {
      var vm = this;
      vm.offset = vm.offset + 30;
      vm.total_count = obj.count;
      obj.data.forEach((element, index) => {
        var redirectLink = this.getAssetLinkFromFavorite(element);
        var timecompare = this.formatTimestamp(element.dateAvailability);
        element["img_link"] = element.content.data.images
          ? vm.rtmImgLinkFiltering(
              element.content.data.images,
              "220x300",
              "title"
            )
          : noImage;
        element["shownewimage"] = timecompare;
        element["redirect_url"] = redirectLink;
        vm.vod_each.push(element);
      });
      this.checkLoadMoreBtn();
      this.initializepageview();
    },
    checkLoadMoreBtn() {
      if (this.offset < this.total_count) {
        this.show_load_more = true;
      } else {
        this.show_load_more = false;
      }
    },
    loadMore() {
      if (this.offset < this.total_count) {
        this.getItems(this.api_link, this.offset);
        this.show_load_more = true;
      } else {
        this.show_load_more = false;
      }
    },
  },

  beforeMount() {
    this.initializeContentForStart();
  },
  mounted() {
    // if back button is pressed
    window.onpopstate = function() {
      this.$router.back();
    };
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 40px;
  min-height: 80vh;
}
.item {
  z-index: 1;
}
.item:hover {
  z-index: 3;
  transform: scale(1.1);
  transition: 0.2s all ease-in-out;
}
h4 {
  color: #dae12f;
  font-family: Inter;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  text-align: center;
}
h1 {
  font-family: Inter;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: left;
  color: #dae12f;
}
.fullwidth {
  min-width: 100% !important;
}
.load-more {
  width: fit-content;
  padding: 8px 20px;
  background-color: #dae12f;
  font-family: Inter;
  border-radius: 4px;
  color: black;
  font-size: 12px;
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .item:hover {
    z-index: 3;
    transform: unset;
    transition: 0.2s all ease-in-out;
  }
}

@media only screen and (max-width: 480px) {
  h1 {
    font-size: 26px;
  }
}
</style>
